var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataId && _vm.formData && _vm.editData)?_c('PcParser',{ref:"formParser",attrs:{"form-data":_vm.formData,"displayData":_vm.editData,"module-uuid":_vm.moduleUuid,"need-flow":!!_vm.formData.need_flow,"form-mode":"detail","disabled":true,"hide-btn":true,"fillData":_vm.formFillData}}):_c('skeleton')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }